import * as moment from "moment";

import { Field, Form, Formik } from "formik";
import React, { Component } from "react";

import { ClipLoader } from "react-spinners";
import DatePicker from "react-datepicker";
import { service } from "../redux";
import { utils } from "~/utils";

/**
 * Component that renders form view to get Bharti approved oet report
 * information.
 */
class BhartiApprovedOetReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadig: false,
            input_circles_value: ""
        };
    }

    render() {
        let date = new Date();
        return (
            <div>
                <div className="container">
                    <div className="col-md-6">
                        <Formik onSubmit={values => this.handleSubmit(values)}>
                            {formik => {
                                const { values, setFieldValue } = formik;
                                return (
                                    <Form>
                                        <div className="row">
                                            <div className="form-group col-md-6">
                                                <label>Start date</label>
                                                <Field
                                                    component={DatePicker}
                                                    dateFormat="dd/MM/yyyy"
                                                    onChange={value => setFieldValue("start_date", value, false)}
                                                    name="start_date"
                                                    autoComplete="off"
                                                    maxDate={date}
                                                    selected={values.start_date}
                                                    className="form-control"
                                                    validate={utils.validateGeneral}
                                                />
                                                {utils.renderError(formik, "start_date")}
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>End date</label>
                                                <Field
                                                    component={DatePicker}
                                                    dateFormat="dd/MM/yyyy"
                                                    onChange={value => setFieldValue("end_date", value, false)}
                                                    name="end_date"
                                                    maxDate={date}
                                                    autoComplete="off"
                                                    selected={values.end_date}
                                                    className="form-control"
                                                    validate={utils.validateGeneral}
                                                />
                                            {utils.renderError(formik, "end_date")}
                                            </div>
                                        </div>
                                        <br></br>
                                        <button type="submit" className="btn btn-success">
                                            Send report to email
                                        </button>
                                        {this.state.isLoadig && (
                                            <div className="float-right">
                                                <ClipLoader />
                                            </div>
                                        )}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }

    handleSubmit = values => {
        /**
        * Method created to handle submission from component form. Here will be
        * executed the service request and handle response as well
        */
        const request = { ...values};
        request.start_date = moment(values.start_date).format("YYYY-MM-DD");
        request.end_date = moment(values.end_date).format("YYYY-MM-DD");
        request.report_name = 'BhartiApprovedOetReport'
        this.setState({ isLoadig: true });
        service.getReportDefault(request)
            .then(response => {
                this.setState({ isLoadig: false })
                utils.show_result_swal(response.data.detail)
            })
            .catch(_ => {
                this.setState({ isLoadig: false });
                utils.errorMessage();
            });
    };
}

export default BhartiApprovedOetReport;
